import { render } from "./TextHeader.vue?vue&type=template&id=a92ccf78&scoped=true"
import script from "./TextHeader.vue?vue&type=script&lang=js"
export * from "./TextHeader.vue?vue&type=script&lang=js"

import "./TextHeader.vue?vue&type=style&index=0&id=a92ccf78&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92ccf78"]])

export default __exports__